import { render } from "./QuizPageOne.vue?vue&type=template&id=1351efe7&scoped=true"
import script from "./QuizPageOne.vue?vue&type=script&lang=js"
export * from "./QuizPageOne.vue?vue&type=script&lang=js"

import "./QuizPageOne.vue?vue&type=style&index=0&id=1351efe7&lang=scss&scoped=true"

import exportComponent from "D:\\Development\\Illyrian\\witsrhi-journeytool-myprep\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1351efe7"]])

export default __exports__